/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import "./Home.css";
import logo from "./Images/584464157_5089777194579876_3779551442085278678_n.jpg";
import { useConfig } from "../../context/ConfigContext";

export default function Home() {
  const { config } = useConfig();
  const apiurl = config.REACT_APP_API_URL;
  const apikey = config.REACT_APP_API_KEY;
   const ApiUrl = config.REACT_APP_GET_MATCH_URL

  const [amount, setAmount] = useState(0);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [date, setDate] = useState()
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showSparkles, setShowSparkles] = useState(false);
  const [sparkles, setSparkles] = useState([]);
  const amountRef = useRef(null);
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await fetch(apiurl, {
          headers: { "Api-Key": apikey },
        });
        const data = await res.json();
        const total =
          Number(
            data?.donated?.amountDonated ??
              data?.amount ??
              data?.donatedAmount ??
              0
          ) || 0;
        setAmount(total);
        setDisplayAmount(total);
      } catch (err) {
        console.error(err);
        setError(true);
        setLoading(false);
      }
    };

    fetchAmount();

    const fetchDate = async () => {
      try {
        const res = await fetch(ApiUrl, {
          headers: { "Api-Key": apikey },
        });
        const data = await res.json();

        setDate(data.date)
        setLoading(false)
      } catch (err) {
        console.error(err);
        setError(true);
        setLoading(false);
      }
    };

    fetchDate();
  }, [apiurl, apikey, ApiUrl]);

  // keep the rest of original component UI
  const generateSparkles = (count = 25) => {
    const newSparkles = Array.from({ length: count }).map((_, i) => ({
      id: i,
      top: Math.random() * 100 + "vh",
      left: Math.random() * 100 + "vw",
      delay: (i * 0.05) + "s",
    }));

    setSparkles(newSparkles);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setTriggerAnimation(true); // allow animation to start
          observer.disconnect(); // important: only trigger once
          }
        },
        { threshold: 0.3 } // 0.3 = 30% of the element must be visible
        );

        if (amountRef.current) {
          observer.observe(amountRef.current);
        }

        return () => observer.disconnect();
      }, []);


  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await fetch(apiurl, { headers: { "Api-Key": apikey } });
        const data = await res.json();

        const total = Number(data.donated.amountDonated) || 0;
        setAmount(total);
        setLoading(false);
      } catch {
        setError(true);
        setLoading(false);
      }
    };
    fetchAmount();
  }, []);

useEffect(() => {
  if (triggerAnimation && !loading && !error) {
    let start = 0;
    const duration = 3000;
    const end = amount;
    const stepTime = 16;
    const increment = (end - start) / (duration / stepTime);

    const counter = setInterval(() => {
      start += increment;

      if (start >= end) {
        start = end;
        clearInterval(counter);

        generateSparkles(100);  
        setShowSparkles(true);
        setTimeout(() => setShowSparkles(false), 2500);
      }

      setDisplayAmount(Math.round(start));
    }, stepTime);

    return () => clearInterval(counter);
  }
}, [triggerAnimation, loading, error, amount]);


  return (
    <section className="home">
      {/* 🌟 Global sparkles */}
      {showSparkles && (
        <div className="sparkle-container">
          {sparkles.map((s) => (
            <span
              key={s.id}
              className="sparkle"
              style={{
                top: s.top,
                left: s.left,
                animationDelay: s.delay,
              }}
            ></span>
          ))}
        </div>
      )}

      <div className="hero improved-hero">
        <img src={logo} alt=""></img>
        <div className="hero-overlay" />

        <div className="hero-content fade-in">
          <h1 className="title-pop">Remembering Bethany Branson. Uniting Community.</h1>
          <p className="subtitle-fade">
            Each year we come together to celebrate Beth’s life with a special memorial match,
            raising funds for charity and sharing memories that matter.
          </p>

          <div className="cta-row">
            <a className="btn btn-primary lift" href="https://square.link/u/wcHJPHfK?src=sheet" target="_blank" rel="noreferrer">Donate Today</a>
            <a className="btn btn-secondary lift" href="/amount-raised">Amount Raised</a>
          </div>
        </div>
      </div>
      
      <div ref={amountRef} className="raised-banner fade-in">
        {loading ? (
          <p className="raised-loading">Loading total raised...</p>
        ) : error ? (
          <p className="raised-error">Could not load total amount.</p>
        ) : (
          <>
            <h2 className="raised-amount">£{displayAmount.toLocaleString()}</h2>
            <p className="raised-sub">Raised so far for charity</p>
          </>
        )}
      </div>

      {showSparkles && (
        <div className="sparkle-container">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </div>
      )}

      <div className="info-grid">
        <div className="card card-animate accent3">
          <h3 className="box-heading">About the Match</h3>
          <p>
            Our memorial match began as a way for us to honour Bethany - a fiercely passionate young woman who loved rugby, loved her teammates, and brought strength, humour and heart to everything she did. It has grown into something truly special: a night where our community comes together to celebrate her, support one another, and raise vital funds for St Giles Animal Welfare and Wooden Spoon, two charities she and her rugby family care about deeply.
            This match isn’t just a game. It’s a chance to feel Bethany’s spirit on the pitch again, to remember the joy she created, and to turn our grief into something positive. Every person who attends helps keep her memory alive and ensures her legacy continues to make a difference.  
          </p>
        </div>

        <div className="card card-animate accent">
          <h3 className="box-heading">When & Where</h3>
          <ul className="list">
            <li><strong>Date:</strong> <em>{date}</em></li>
            <li><strong>Kick-off:</strong> <em>7:30 PM</em></li>
            <li><strong>Venue:</strong> <em>Bridgwater & Albion RFC</em></li>
            <li><strong>Location:</strong> <em>Bath Road, Bridgwater</em></li>
          </ul>
        </div>

        <div className="card card-animate accent2">
          <h3 className="box-heading">Get Involved</h3>
          <p>
            There are so many ways to be part of our memorial match, and every single one makes a difference. You can donate raffle or auction prizes, buy raffle tickets on the night, or take part in our auctions - all of which help raise vital funds for St Giles Animal Welfare and Wooden Spoon. You can also support by simply coming along, filling the stands, and helping create the incredible atmosphere that makes this event so special.
            
            We’re endlessly grateful to the wonderful players who give up their time to put on a brilliant game of women’s rugby in Bethany’s honour. Your involvement, in any form, helps keep Bethany's spirit alive and allows us to continue building something positive and powerful in her name.  
          </p>
        </div>
      </div>

      {/* 🌟 NEW FACEBOOK COMMUNITY SECTION */}
      <div className="fb-cta fade-in">
        <h2>Join Our Facebook Community</h2>
        <p>Stay updated with announcements, photos & event news.</p>

        <div className="fb-row">
          <svg className="facebook-logo" xmlns="http://www.w3.org/2000/svg" x="0px" y="0" width="50" height="50" viewBox="0 0 48 48">
            <path fill="#3F51B5" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path>
            <path fill="#FFF" d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"></path>
          </svg>

          <a
            href="https://www.facebook.com/groups/bethbranson"
            target="_blank"
            rel="noopener noreferrer"
            className="btn fb-btn"
          >
            Visit Facebook Group
          </a>
          <svg className="facebook-logo" xmlns="http://www.w3.org/2000/svg" x="0px" y="0" width="50" height="50" viewBox="0 0 48 48">
            <path fill="#3F51B5" d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"></path>
            <path fill="#FFF" d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"></path>
          </svg>
        </div>
      </div>

    </section>
  );
}